import { useMutation } from 'react-query';

import { editUser } from 'shared/api/users/http';

const useMutateEditUser = (options = undefined) => useMutation(({ id, user }) => editUser(id, user), options);

export default useMutateEditUser;
